import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jsmWorkItemBrowseRoute: InvariantJiraRoute = {
	name: 'jsm-work-item-browse',
	path: '/jira/servicedesk/browse/:issueKey(\\w+-\\d+)(.*)?',
	exact: true,
};
